export const DAY_OF_WEEK_OPTIONS = [
  { id: '1', name: 'Mon', fullName: 'Monday' },
  { id: '2', name: 'Tue', fullName: 'Tuesday' },
  { id: '3', name: 'Wed', fullName: 'Wednesday' },
  { id: '4', name: 'Thu', fullName: 'Thursday' },
  { id: '5', name: 'Fri', fullName: 'Friday' },
  { id: '6', name: 'Sat', fullName: 'Saturday' },
  { id: '7', name: 'Sun', fullName: 'Sunday' },
]
